import type {FC} from 'react';
import {Alert,} from 'reactstrap';
import {useUser} from '@touchnet/user-management';
import {UserAccountStatus} from '@tn-types/user-service'

interface ComponentProps {
    urn: string;
}

export const UserSummaryBar: FC<ComponentProps> = (props: ComponentProps) => {
    const {
        urn,
    } = props;

    const details = useUser(urn);

    const statusMap: { [key in UserAccountStatus]: string } = {
        [UserAccountStatus.ACTIVE]: 'Active',
        [UserAccountStatus.DISABLED]: 'Disabled',
        [UserAccountStatus.LOCKED]: 'Locked',
    };

    return (
        <Alert color="secondary">
            <div className="row">
                <div className="col">
                    <strong>User Name:</strong>
                    <br/>
                    {details.userName}
                </div>
                <div className="col">
                    <strong>Full Name:</strong>
                    <br/>
                    {`${details.givenName} ${details.familyName}`}
                </div>
                <div className="col">
                    <strong>Email:</strong>
                    <br/>
                    {details.emailAddress}
                </div>
                <div className="col">
                    <strong>Status:</strong>
                    <br />
                    {statusMap[details.status]}
                </div>
            </div>
        </Alert>
    );
};

export default UserSummaryBar;
